import { h } from 'preact';

const TwitterIcon = () => (

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 6.69C21.88 6.16 22.56 5.32 22.88 4.31C22.05 4.81 21.13 5.16 20.16 5.36C19.37 4.5 18.26 4 17 4C14.65 4 12.73 5.92 12.73 8.29C12.73 8.63 12.77 8.96 12.84 9.27C9.28004 9.09 6.11004 7.38 4.00004 4.79C3.63004 5.42 3.42004 6.16 3.42004 6.94C3.42004 8.43 4.17004 9.75 5.33004 10.5C4.62004 10.5 3.96004 10.3 3.38004 10C3.38004 12.11 4.86004 13.85 6.82004 14.24C6.46004 14.34 6.08004 14.39 5.69004 14.39C5.42004 14.39 5.15004 14.36 4.89004 14.31C5.43004 16 7.00004 17.26 8.89004 17.29C7.43004 18.45 5.58004 19.13 3.56004 19.13C3.22004 19.13 2.88004 19.11 2.54004 19.07C4.44004 20.29 6.70004 21 9.12004 21C17 21 21.33 14.46 21.33 8.79C21.33 8.6 21.33 8.42 21.32 8.23C22.16 7.63 22.88 6.87 23.46 6C22.69 6.35 21.86 6.58 21 6.69Z" fill="currentColor" />
</svg>


);

export default TwitterIcon;